import * as actionType from "./constants";

const initialState = {
    getBuildingAgeColorDataResponse: {},
    updateBuildingAgeColorResponse: { isLoading: false }
};
export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_BUILDING_AGE_CATEGORIES_DATA_REQUEST:
            return {
                ...state,
                getBuildingAgeColorDataResponse: { isLoading: true }
            };
        case actionType.GET_BUILDING_AGE_CATEGORIES_DATA_SUCCESS:
            return {
                ...state,
                getBuildingAgeColorDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_BUILDING_AGE_CATEGORIES_DATA_FAILURE:
            return {
                ...state,
                getBuildingAgeColorDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_BUILDING_AGE_CATEGORIES_REQUEST:
            return {
                ...state,
                updateBuildingAgeColorResponse: { isLoading: true }
            };
        case actionType.UPDATE_BUILDING_AGE_CATEGORIES_SUCCESS:
            return {
                ...state,
                updateBuildingAgeColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_BUILDING_AGE_CATEGORIES_FAILURE:
            return {
                ...state,
                updateBuildingAgeColorResponse: { isLoading: false, success: false, ...action.error }
            };
        default:
            return state;
    }
};
